import React, { useContext } from 'react';
import { LanguageContext } from "../context/LanguageContext";
import { GERMAN } from "../actions/language";
import PageHero from "./common/PageHero";
import CtaBand from "./common/CtaBand";

const Administration = () => {
    const { language } = useContext(LanguageContext);
    const de = language === GERMAN;

    const features = [
        {
            icon: 'fas fa-file-invoice',
            title: de ? 'Rechnungen nach Vorgabe' : 'Faturas por especificação',
            text: de
                ? 'Auf Basis Ihrer Vorgaben erstellen wir korrekte und ansprechende Rechnungen, die sowohl rechtlichen als auch geschäftlichen Anforderungen entsprechen.'
                : 'Com base nas suas especificações, criamos faturas corretas e apelativas que cumprem os requisitos legais e comerciais.'
        },
        {
            icon: 'fas fa-file-alt',
            title: de ? 'Professionelle Angebote' : 'Orçamentos profissionais',
            text: de
                ? 'Wir erstellen Angebote, die nicht nur inhaltlich überzeugen, sondern auch optisch beeindrucken. So präsentieren Sie sich stets von Ihrer besten Seite.'
                : 'Criamos orçamentos que não só convencem pelo conteúdo, mas também impressionam visualmente. Apresenta-se sempre da melhor forma.'
        },
        {
            icon: 'fas fa-envelope-open-text',
            title: de ? 'Verwaltung des Briefverkehrs' : 'Gestão da correspondência',
            text: de
                ? 'Von der Bearbeitung eingehender Schreiben bis zur Versendung Ihrer Korrespondenz – wir halten den Kommunikationsfluss am Laufen.'
                : 'Do processamento das cartas recebidas ao envio da sua correspondência – mantemos o fluxo de comunicação a funcionar.'
        },
        {
            icon: 'fas fa-sitemap',
            title: de ? 'Strukturierte Prozesse' : 'Processos estruturados',
            text: de
                ? 'Wir strukturieren Ihre administrativen Abläufe und sorgen mit Sorgfalt und Blick fürs Detail dafür, dass Ihre Büroangelegenheiten in besten Händen sind.'
                : 'Estruturamos os seus fluxos administrativos e, com cuidado e atenção ao detalhe, garantimos que os assuntos do seu escritório estão nas melhores mãos.'
        }
    ];

    return (
        <main>
            <PageHero
                eyebrow={de ? 'Leistung 03 — Verwaltung' : 'Serviço 03 — Administração'}
                title={de
                    ? <span>Effiziente Organisation für <em>Ihren Erfolg</em>.</span>
                    : <span>Organização eficiente para <em>o seu sucesso</em>.</span>}
                lede={de
                    ? 'Eine gut organisierte Verwaltung ist das Rückgrat eines erfolgreichen Unternehmens. Wir entlasten Sie bei alltäglichen Büroangelegenheiten – professionell, zuverlässig und mit Blick fürs Detail.'
                    : 'Uma administração bem organizada é a espinha dorsal de uma empresa de sucesso. Libertamo-lo das tarefas diárias de escritório – de forma profissional, fiável e com atenção ao detalhe.'}
            />

            <section className="tm-section">
                <div className="tm-container">
                    <div className="tm-section__head">
                        <span className="tm-eyebrow">{de ? 'Unsere Verwaltungsleistungen' : 'Os nossos serviços administrativos'}</span>
                        <h2 className="tm-section__title">
                            {de
                                ? <span>Das Rückgrat <em>Ihres Unternehmens</em>.</span>
                                : <span>A espinha dorsal <em>da sua empresa</em>.</span>}
                        </h2>
                    </div>
                    <div className="tm-features">
                        {features.map((f, i) => (
                            <div key={i} className="tm-feature">
                                <span className="tm-feature__icon"><i className={f.icon}/></span>
                                <h3>{f.title}</h3>
                                <p>{f.text}</p>
                            </div>
                        ))}
                    </div>

                    <div className="tm-callout" style={{ marginTop: "56px" }}>
                        <i className="fas fa-clock"/>
                        <div>
                            <h3>{de ? 'Warum uns wählen?' : 'Porquê escolher-nos?'}</h3>
                            <p>
                                {de
                                    ? 'Mit unserer Unterstützung sparen Sie Zeit, reduzieren Ihre Arbeitsbelastung und steigern die Effizienz Ihrer Verwaltung. Unser Anspruch ist es, Ihre Erwartungen zu übertreffen und Ihnen mit einem ganzheitlichen Ansatz den höchstmöglichen Nutzen zu bieten.'
                                    : 'Com o nosso apoio, poupa tempo, reduz a carga de trabalho e aumenta a eficiência da sua administração. O nosso objetivo é exceder as suas expectativas e oferecer-lhe o maior benefício possível com uma abordagem holística.'}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <CtaBand/>
        </main>
    );
};

export default Administration;



// WEBPACK FOOTER //
// ./src/components/Administration.js